/* global $ */

import cookie from '../helpers/cookie';

const COOKIE_TTL = 365;
const $modal = $('.js-vacancy-request-modal');
const COOKIE = $modal.data('vacancyRequestModalCookie');

const vacancyRequestModal = {
  initialize() {
    if ($modal.length) {
      this.createEvents();

      $modal.on('submit', () => {
        cookie.set(COOKIE, '1', COOKIE_TTL);
      });
    }
  },

  createEvents() {
    this.openAfterInMilliseconds = parseInt($modal.data('vacancyRequestModalOpenAfter'), 10) * 1000;

    setTimeout(() => {
      $modal.modal('show');
    }, this.openAfterInMilliseconds);

    $modal.on('hide.bs.modal', () => {
      cookie.set(COOKIE, '1', COOKIE_TTL);
    });
  },
};

export default vacancyRequestModal;
